const awsmobile = {
  "aws_appsync_region": "ap-southeast-2",
  "aws_appsync_authenticationType": "API_KEY",
  "aws_appsync_graphqlEndpoint": "https://yx3evpboifd4jk4qspq4e5vw2m.appsync-api.ap-southeast-2.amazonaws.com/graphql",
  "aws_appsync_apiKey": "da2-gi6vpebbbfdlxfvrxlah75ektq"
};

export default awsmobile;
